import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumberOnly]',
  standalone: false,
})
export class InputNumbersOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const initalValue = this.el.nativeElement.value;
    let val = initalValue.replace(/[^0-9]*/g, '');
    if (Number.isNaN(val)) {
      val = 0;
    }
    this.el.nativeElement.value = val;
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
